package com.schoolconnect.app.feature.itusers.add

import androidx.compose.ui.graphics.Color
import com.schoolconnect.app.feature.itusers.ITUserRoleUi
import com.schoolconnect.app.feature.itusers.ITUserStatusUi
import com.schoolconnect.app.feature.itusers.ITUserFormErrors
import com.schoolconnect.app.feature.itusers.ITUserFormValues
import com.schoolconnect.app.feature.itusers.isValidITUserEmail
import com.schoolconnect.app.feature.itusers.isValidITUserMobile
import com.schoolconnect.app.feature.itusers.roleFromLabel
import com.schoolconnect.app.feature.itusers.sanitizeITUserMobile
import com.schoolconnect.app.feature.itusers.statusFromLabel
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.headset
import ischoolconnect.sharedui.generated.resources.shield
import ischoolconnect.sharedui.generated.resources.user_cog
import org.jetbrains.compose.resources.DrawableResource

internal data class AddITUserRoleOptionUi(
    val role: ITUserRoleUi,
    val label: String,
    val icon: DrawableResource,
    val tileColor: Color,
    val iconTint: Color
)

internal data class AddITUserStatusOptionUi(
    val status: ITUserStatusUi,
    val label: String
)

internal val addITUserRoleOptions: List<AddITUserRoleOptionUi> = listOf(
    AddITUserRoleOptionUi(
        role = ITUserRoleUi.SUPER_ADMIN,
        label = "IT Super Admin",
        icon = Res.drawable.user_cog,
        tileColor = Color(0xFFEFE7FF),
        iconTint = Color(0xFF6B2CE6)
    ),
    AddITUserRoleOptionUi(
        role = ITUserRoleUi.IT_ADMIN,
        label = "IT Admin",
        icon = Res.drawable.shield,
        tileColor = Color(0xFFEAF2FF),
        iconTint = Color(0xFF2563EB)
    ),
    AddITUserRoleOptionUi(
        role = ITUserRoleUi.IT_SUPPORT,
        label = "IT Support",
        icon = Res.drawable.headset,
        tileColor = Color(0xFFE8F8EF),
        iconTint = Color(0xFF16A34A)
    )
)

internal val addITUserStatusOptions: List<AddITUserStatusOptionUi> = listOf(
    AddITUserStatusOptionUi(ITUserStatusUi.ACTIVE, "Active"),
    AddITUserStatusOptionUi(ITUserStatusUi.INACTIVE, "Inactive")
)

internal fun validateAddITUser(values: AddITUserFormValues): AddITUserFormErrors {
    val mobile = sanitizeITUserMobile(values.mobile)
    return ITUserFormErrors(
        name = if (values.name.trim().isBlank()) "Enter full name" else "",
        mobile = if (isValidITUserMobile(mobile)) "" else "Enter a valid Indian mobile number",
        email = if (isValidEmail(values.email)) "" else "Enter a valid email address",
        role = if (roleFromLabel(values.role) == null) "Select role" else "",
        status = if (statusFromLabel(values.status) == null) "Select status" else ""
    )
}

internal fun isValidEmail(value: String): Boolean {
    return isValidITUserEmail(value)
}
